interface IDeviceCapabilities {
    camera?: boolean;
    cameraFront?: boolean;
    cameraRear?: boolean;
    cashdrawer?: boolean;
}

export interface IDevicePrinter {
    feedPost?: number;
    charWidth?: number;

    // Device printer widths:
    // 26 chars: PAX A920
    // 32 chars: Sunmi V2s, Sunmi D3 Mini (narrow printer), Castles S1F2 (Adyen)
    // 38 chars: PAX E500, PAX E700, PAX E800
    // 48 chars: Sunmi T2s, Sunmi V3 Mix, Sunmi D3 Mini (wide printer)
    columns?: 26 | 32 | 38 | 48;
}

export interface IDeviceProfile {
    id: string;
    osName: "ios" | "android" | "web";
    osVersion: string | number;
    appVersion: string;
    appBuild: string;
    serialNumber?: string;
    hardwareModel: string;
    hardwareProducer: string;
    macAddress?: string;
    language: string; // Returns language code of the best available language. e.g "da" or "en".
    capabilities: IDeviceCapabilities;
    printer: IDevicePrinter;
    isUsingAutoTime?: boolean;
    isUsingAutoTimeZone?: boolean;
    timeZone?: string;
}

// react-native-device-info has the annoying feature that if something isn't available;
// they say "unknown" instead of undefined
export function unknownToUndefined(text: string): string | undefined {
    if (text === "unknown") {
        return undefined;
    }
    return text;
}

/**
 * Sorry, I disabled this for now we probably want to control this through the admin interface -Andri
 * Defaults to danish
 */
export function getLanguage() {
    return "da";
}
